import { Carousel } from '@design-system';

import { ImageCardLink } from './ImageCardLink';

interface Props {
  images: ImageCardLinkBlok[];
  onLinkClick?: (href: string, title?: string) => void;
  title?: string;
}

export const ImageLinkGroup = ({ images, onLinkClick, title }: Props) => {
  return (
    <Carousel
      arrowPosition={title ? 'top' : 'middle'}
      headline={title}
      items={images.map((item) => (
        <ImageCardLink item={item} onClick={onLinkClick} />
      ))}
      perPage={3}
    />
  );
};
